import { useState } from 'react';
import { supabase } from '../utils/supabase';

function UserMessageBox({ user, compact = false, onClose }) {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSend = async () => {
    if (!message.trim() || !user?.id) return;
    setSending(true);
    setError('');
    const { error: insertError } = await supabase
      .from('notifications')
      .insert({ user_id: user.id, message: message.trim() });
    setSending(false);
    if (insertError) {
      setError('Could not send message.');
      return;
    }
    setSent(true);
    setMessage('');
    setTimeout(() => {
      setSent(false);
      onClose?.();
    }, 1200);
  };

  return (
    <div className={`bootcamp-user-message-box${compact ? ' bootcamp-user-message-box--compact' : ''}`}>
      <textarea
        className="bootcamp-user-message-box-input"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={compact ? 2 : 4}
        placeholder="Write a notification…"
        disabled={sending}
      />
      {error && <div className="bootcamp-user-message-box-error">{error}</div>}
      {sent && <div className="bootcamp-user-message-box-sent">Sent.</div>}
      <div className="bootcamp-user-message-box-actions">
        {compact && onClose && (
          <button
            type="button"
            className="modern-button modern-button-secondary bootcamp-user-message-box-cancel"
            onClick={onClose}
            disabled={sending}
          >
            Cancel
          </button>
        )}
        <button
          type="button"
          className="modern-button modern-button-secondary bootcamp-user-message-box-send"
          onClick={handleSend}
          disabled={sending || sent || !message.trim()}
        >
          {sent ? 'Sent' : sending ? 'Sending…' : 'Send'}
        </button>
      </div>
    </div>
  );
}

export default UserMessageBox;
